import { Row, Txt } from '@stenajs-webui/core';
import type { FC } from 'react';
import {
  getGridColumnLabel,
  getPotentiallyShortColumnLabel,
} from '../../../../common/utils/columns/gridColumns';
import type { SearchResultColumn } from '../utils/searchResultColumns';

export interface BookingSearchTableHeaderRowProps {
  searchColumns: SearchResultColumn[];
}

export const BookingSearchTableHeaderRow: FC<BookingSearchTableHeaderRowProps> = ({
  searchColumns,
}) => {
  return (
    <Row indent={2}>
      {searchColumns.map(column => {
        return (
          <Row
            className={column.columnId}
            alignItems={'center'}
            spacing
            key={column.columnId}
            width={column.remWidth + 'rem'}
            height={40}
          >
            <Txt size={'small'} title={getGridColumnLabel(column.columnId)}>
              {getPotentiallyShortColumnLabel(column.columnId)}
            </Txt>
          </Row>
        );
      })}
    </Row>
  );
};
